import {BugOutlined} from '@ant-design/icons'
import IconWithNotification from '../../../SidePanel/LeftPanel/IconWithNotification.jsx'
import SyntaxPane from './SyntaxPane.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const report = map.syntax.useReport()

    if (! map.syntax.isAvailable) {
        return null
    }

    return {
        icon: (
            <IconWithNotification notification={0 < report?.errors.length}>
                <BugOutlined />
            </IconWithNotification>
        ),

        key: 'syntax',
        name: '规范性检测',
        pane: <SyntaxPane report={report} />,
    }
}
